import React from "react";

import { CloudFilePreviewContext } from "../context/CloudFilePreviewContext";

export const useCloudFilePreviewContext = () => {
    const context = React.useContext(CloudFilePreviewContext);

    if (!context) {
        throw new Error("useCloudFilePreviewContext must be used within a CloudFilePreviewProvider");
    }

    return context;
};
